import axios from "axios";

const httpRenavamClientGateway = axios.create({
  baseURL: process.env.GATEWAY_URL || "",
  timeout: 2 * 60 * 1000,
  headers: {},
});

export default httpRenavamClientGateway;
